module.exports = __webpack_public_path__ + "img/40_69_004_000.0c8381a3.jpg";